/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { VocabWordAdminSenseViewDto } from "./VocabWordAdminSenseViewDto";
export type VocabWordAdminDto = {
  id: string;
  lemma: string;
  /**
   * 언어
   */
  language: VocabWordAdminDto.language;
  /**
   * 읽기 (일본어 전용, 영어는 null)
   */
  reading: string | null;
  /**
   * JLPT 급수 (일본어 전용, 영어는 null)
   */
  jlptLevel: VocabWordAdminDto.jlptLevel | null;
  ipa: string;
  /**
   * 단어 TTS URL
   */
  audio: string | null;
  examTags: Array<string>;
  senses: Array<VocabWordAdminSenseViewDto>;
  /**
   * 소프트 삭제 여부
   */
  isDeleted: boolean;
  /**
   * 이 단어를 학습한 유저 상태 수 (삭제 경고용)
   */
  learnerCount: number;
  createdAt: string;
  updatedAt: string;
};
export namespace VocabWordAdminDto {
  /**
   * 언어
   */
  export enum language {
    EN = "en",
    JA = "ja",
    KO = "ko",
  }
  /**
   * JLPT 급수 (일본어 전용, 영어는 null)
   */
  export enum jlptLevel {
    N5 = "N5",
    N4 = "N4",
    N3 = "N3",
    N2 = "N2",
    N1 = "N1",
  }
}
